import { Component } from "@angular/core";

@Component({
  selector: "db-dot-loader",
  templateUrl: "./dot-loader.component.html",
  styleUrls: ["./dot-loader.component.scss"],
  standalone: true,
})
export class DotLoaderComponent {}
